<template>
  <section class="ct-banner-feed">
    <div class="ct-banner-feed__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <ClientOnly>
          <VueCarousel
            v-if="slice?.FeedDisplay?.Display === 'Slider'"
            v-bind="sliderSettings"
            ref="carousel"
          >
            <VueSlide
              v-for="(banner, index2) in slice?.Banners"
              :key="banner"
            >
              <StrapiBanner
                :banner="banner"
                :lazy="index > 0 && index2 > 0"
                :banner-count="slice?.Banners?.length"
                :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
                class="ct-banner-feed__banner"
              />
            </VueSlide>

            <template #addons>
              <div
                v-if="showNavigation"
                class="carousel__navigation"
                :class="{ 'carousel__navigation--center': navPositionCenter }"
              >
                <VueNavigation>
                  <template #prev>
                    <IconArrow class="carousel__icon icon icon--arrow icon--arrow-left" />
                  </template>
                  <template #next>
                    <IconArrow class="carousel__icon icon icon--arrow icon--arrow-right" />
                  </template>
                </VueNavigation>
              </div>
            </template>
          </VueCarousel>

          <div
            v-else-if="slice?.FeedDisplay?.Display === 'Grid'"
            class="ct-banner-feed__grid"
            :style="`
              --columns: ${totalColumns};
              --max-columns: ${maxColumns};
            `"
          >
            <StrapiBanner
              v-for="(banner, index2) in slice?.Banners"
              :key="banner"
              :banner="banner"
              :lazy="!(index === 0 && index2 === 0)"
              :banner-count="slice?.Banners?.length"
              :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
              :class="['ct-banner-feed__banner', { 'banner--hero': slice?.Banners?.length === 1 && slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width' }]"
            />
          </div>
        </ClientOnly>
      </div>
      <div
        v-if="showMoreText"
        class="ct-banner-feed__show-more"
      >
        <AppLink
          :to="slice.FeedDisplay.ShowMoreLink"
          class="button--link button"
        >
          <span>{{ slice?.FeedDisplay?.ShowMoreLabel }}</span>
          <IconArrowarrow
            class="icon icon--arrow"
          />
        </AppLink>
      </div>

      <!-- <DevOnly v-if="slice?.FeedDisplay?.Display === 'Slider'"><pre>sliderSettings: {{ sliderSettings }}</pre></DevOnly> -->
      <!--  -->
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { settings } = useSliderSettings()
const sliderSettings = Object.assign({}, settings, {
  itemsToShow: 1.25,
  snapAlign: 'start',
  breakpoints: {
    640: {
      itemsToShow: Math.min(3, props.slice?.Banners?.length),
    },
    1024: {
      itemsToShow: Math.min(4, props.slice?.Banners?.length),
    },
    1280: {
      itemsToShow: Math.min(5, props.slice?.Banners?.length),
    },
  },
})

const carousel = ref()
const showNavigation = computed(() => {
  return props.slice?.Banners?.length > carousel.value?.data?.config?.itemsToShow
})

const totalColumns = computed(() => {
  return props.slice?.Banners?.length ?? 0
})

const maxColumns = computed(() => {
  const columnsPerRow = props.slice?.FeedDisplay?.ColumnsPerRow
  console.log('slice', props.slice)

  const columnMap: Record<string, number> = {
    four: 4,
    six: 6,
  }

  return columnMap[columnsPerRow ?? ''] ?? 3
})

const showMoreText = computed(() => {
  return props.slice?.FeedDisplay?.ShowMoreLabel && props.slice?.FeedDisplay?.ShowMoreLink
})

const navPositionCenter = computed(() => {
  return props.slice?.FeedDisplay?.NavigationPosition === 'center'
})
</script>

<style>
@import url("~layers/app/assets/css/vue3-carousel-nuxt.css");
@import url("~layers/app/components/Slices/BannerFeed.css");
</style>
